import { Component } from '@angular/core';
import { faCalendar } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FullCalendarComponent } from "../components/full-calendar/full-calendar.component";
import { EventListComponent } from '../components/event-list/event-list.component';
import { EventService } from '../services/event.service';
import { MarketPageService } from '../services/market-page.service';
import { Farm, Event } from '../../models/types';

@Component({
  selector: 'app-calendar-page',
  standalone: true,
  imports: [FontAwesomeModule, FullCalendarComponent, EventListComponent],
  templateUrl: './calendar-page.component.html',
  styleUrl: './calendar-page.component.scss'
})
export class CalendarPageComponent {
  faCalendar = faCalendar;
  isOnMarketPage = true;
  allFarms: Farm[] = [];
  allEvents: Event[] = [];

  constructor(private eventService: EventService,
              private marketPageService: MarketPageService
  ) {}

  ngOnInit() {
    this.loadEvents();
    this.loadFarms();
    
  }

  loadEvents() {
    this.eventService.getAllEvents().subscribe((response) => {
      this.allEvents = response.events!;
      this.allEvents = response.events!.filter((event: Event) => event.organisationName !== 'old_hall');
    });
  }

  loadFarms() {
    this.marketPageService.getAllFarms().subscribe((response) => {
      this.allFarms = response.body!.farms;
    });
  }
}
